export const inBetween = (actual, min, max) => {
    if (actual < min) {
        return min;
    }
    if (actual > max) {
        return max;
    }
    return actual;
};
